export enum ScenarioName {
  // Life cycle
  AppStart = "app_start",
  CoreInitialize = "core_initialize",
  DownloadAndParse = "download_and_parse",
  ResolveMainImports = "resolve_main_imports",
  DomLoadingStart = "dom_loading_start",
  RestorePersistedWindows = "restore_persisted_windows",
  WindowLaunchTime = "window_launch_time",
  DynamicImport = "dynamic_import",

  // Actions
  AcquireToken = "acquire_token",
  AcquireTokenInBackground = "acquire_token_in_background",
  AppCtxProviderWait = "app_ctx_provider_wait",
  CentralDataLayerSubscription = "cdl_subscription_agg",
  CentralDataLayeRequest = "cdl_request",
  CentralDataLayerWorkerStartup = "cdl_worker_startup",
  CentralDataLayerWorkerManagerStartup = "cdl_worker_manager_startup",
  ComposeDisabled = "compose_disabled",
  ChatSendMessage = "chat_send_message",
  GetAuthUser = "get_auth_user",
  GetSkypeToken = "get_skype_token",
  IndexedDBFetch = "indexed_db_fetch",
  LongPollRecovery = "long_poll_recovery",
  LongPollError = "long_poll_error",
  QueryExecution = "query_exec",
  SubscriptionCloseExecution = "subscription_close_exec",
  SubscriptionOpenExecution = "subscription_open_exec",
  FatalError = "fatal_error",
  GlobalWindowError = "global_window_error",
  UnhandledRejection = "unhandled_rejection",
  GarbageCollection = "garbage_collection",
  AuthHandlerRequest = "auth_handler_request",

  // Rendering
  RenderChatList = "render_chat_list",
  RenderComposeChat = "render_compose_chat",
  RenderCallingDefault = "render_calling_default",
  RenderCallsTab = "render_calls_tab",
  RenderCallingJoin = "render_calling_join",
  RenderCallingScreenManager = "render_calling_screen_manager",
  RenderCallingPreJoin = "render_calling_prejoin",
  RenderCallingScreen = "render_calling_screen",
  // i18n
  I18nMissingInterpolationHandler = "i18n_missing_interpolation_handler",
  I18nMissingKeyHandler = "i18n_missing_key_handler",
  I18nNamespaceLoad = "i18n_namespace_load",
  I18nGetLocaleInfo = "i18n_get_locale_info",

  // File
  RenderFileViewer = "render_file_viewer",
  RenderFileEmailViewer = "render_file_email_viewer",
  MainImportToDomContentLoaded = "main_import_to_dom_content_loaded",
  FilePreviewLayoutToJsApiScriptLoad = "file_preview_layout_to_jsapi_script_load",
  JsApiScriptLoad = "jsapi_script_load",
  JsApiFirstStep = "jsapi_first_step",
  JsApiSecondStep = "jsapi_second_step",
  FileRedeem = "documents_file_redeem",

  // Chat List Filtering
  ChatListFiltering = "chat_list_filtering",

  // Send Feedback
  SendFeedback = "send_feedback",

  // Personal site info
  FetchPersonalSiteInfo = "fetch-personal-site-info",

  // Create File chiclet on link paste
  CreateFileChiclet = "documents_create_file_chiclet_on_link_paste",

  // FilesPersonalPicker
  RenderFilesPersonalPicker = "render_files_personal_picker",
  FilesPersonalPicker = "files_personal_picker",

  // File Upload
  FileUploadChatPicker = "documents_upload_file_chat_file_picker",
  FileUploadChatConflict = "documents_upload_file_chat_conflict_dialog",
  FileUploadChatDragNDrop = "documents_upload_file_chat_drag_and_drop",
  FileRemovalChat = "documents_remove_file_chat",
  FileAttachChat = "documents_attach_file_chat",
  FileUploadMeetingPicker = "documents_upload_file_meeting_file_picker",
  FileUploadMeetingConflict = "documents_upload_file_meeting_conflict_dialog",
  FileUploadMeetingDragNDrop = "documents_upload_file_meeting_drag_and_drop",
  FileRemovalMeeting = "documents_remove_file_meeting",
  FileAttachMeeting = "documents_attach_file_meeting",
  FilesAMSImageUpload = "documents_ams_image_upload",

  // File Chiclet and Sharing
  FileChicletDefaultPermission = "documents_share_link_chiclet_default_permission",
  FileChicletExistingPermission = "documents_share_link_chiclet_existing_permission",
  FileSharingPermissionDialog = "documents_share_link_permission_dialog",
  FileSharingCopyLinkDialog = "documents_share_link_copy_dialog",

  // File chiclet actions
  FileOpenInDesktopApp = "documents_action_open_office_file_app",
  FileDownload = "documents_action_download_file",
  FileOpenOnline = "documents_action_open_file_online",

  // Meeting options
  MeetingOptionsCore = "meeting_options_core",
  MeetingOptionsChanged = "meeting_options_changed",
  MeetingOptionsStart = "meeting_options_start",
  MeetingOptionsGet = "meeting_options_get",
  MeetingOptionsSet = "meeting_options_set",

  // Messaging
  AmsImageApiLoad = "ams_image_api_load",
  AmsImageBrowserLoad = "ams_image_browser_load",
  AmsImageUpload = "ams_image_upload",
  OnDemandTranslation = "on_demand_translate_message",
  AudioFileDownload = "audio_file_download",
  PrivateChatPolicyDefined = "private_chat_policy_defined",

  // People Picker
  PeoplePickerRemote = "people_picker_load_results",
  PeoplePickerCache = "people_picker_load_results_clientonly",
  PeoplePickerResolveUserRemote = "people_picker_resolve_user_remote",
  PeoplePickerPstnAssignmentRemote = "people_picker_pstn_resolve_user_remote",
  PeoplePicker3S = "people_picker_3s",
  PeoplePickerAAD = "people_picker_aad",
  PeoplePickerIDB = "people_picker_indexeddb",
  PeoplePickerResolveUserOnSelection = "people_picker_resolve_user_on_selection",

  // Wiki
  CreateWiki = "wikiv2_create_wiki",
  LoadWiki = "wikiv2_load_wiki",
  DeleteWiki = "wikiv2_delete_wiki",
  SavePageTitleWiki = "wikiv2_save_page_title",
  LockSectionWiki = "wikiv2_lock_section",
  SaveSectionWiki = "wikiv2_save_section",
  AddPageWiki = "wikiv2_add_page",
  DeletePageWiki = "wikiv2_delete_page",
  MovePageWiki = "wikiv2_move_page",
  MoveSectionWiki = "wikiv2_move_section",
  DeleteSectionWiki = "wikiv2_delete_section",
  ForceUnlockWiki = "wikiv2_force_unlock",
  AddSectionWiki = "wikiv2_add_section",
  DiscardSectionWiki = "wikiv2_discard_section",
  LoadPageWiki = "wikiv2_load_page",
  FocusSectionWiki = "wikiv2_focus_section",
  LoadPagesForSidebarWiki = "wikiv2_load_pages_for_sidebar",
  LoadPageWithoutSectionWiki = "wikiv2_load_page_without_section",
  LoadSectionWiki = "wikiv2_load_section",

  // Scheduler diagnostics
  SyncJobScheduler = "sync_job_scheduler",

  // Sync Jobs
  NoOpSyncJob = "noop_sync_job",
  MessageSyncJob = "message_sync_job",
  RelatedMessageSyncJob = "related_message_sync_job",
  StartupSyncJob = "startup_sync_job",
  ThreadDetailsSyncJob = "thread_details_sync_job",
  BatchedThreadDetailsSyncJob = "batched_thread_details_sync_job",
  ReplyChainSyncJob = "replychain_sync_job",

  // Pruning Jobs
  PersistencePruningJob = "persistence_pruning_job",
  RetentionPruningJob = "retention_pruning_job",
  ActivityFeedPruningJob = "activity_feed_pruning_job",

  // Sync Workflows
  MessageSyncWorkflow = "message_sync_workflow",
  DeltaSyncWorkflow = "delta_sync_workflow",
  ConversationSyncWorkflow = "conversation_sync_workflow",
  ThreadDetailsWorkflow = "thread_details_workflow",
  ReplyChainWorkflow = "reply_chain_workflow",
  ExtendHistoryWorkflow = "extend_history_workflow",
  RelatedMessageSyncWorkflow = "related_message_sync_workflow",

  // Other workflows
  MaintenanceWorkflow = "maintenance_workflow",

  // Sync Strategies
  OnActiveConversationStrategy = "on_active_conversation_strategy",
  OnStartupOrIntervalStrategy = "on_startup_or_interval_strategy",
  OnLoadMoreStrategy = "on_load_more_strategy",
  OnLongPollReceivedStrategy = "on_long_poll_received_strategy",
  OnAppStateActiveStrategy = "on_app_state_active_strategy",
  OnAppStateInactiveStrategy = "on_app_state_inactive_strategy",
  OnForceRunMaintenanceWorkflow = "on_force_run_maintenance_workflow",
  OnPrefetchReplyChainsFromDb = "on_prefetch_reply_chains_from_db",
  // Manager
  ReplyChainManagerGetReplyChains = "reply_chain_manager_get_reply_chains",
  ReplyChainManagerGetReplyChain = "reply_chain_manager_get_single_reply_chain",
  ReplyChainManagerGetReplyChainsByKeys = "reply_chain_manager_get_reply_chains_by_keys",
  // Resolvers
  GetTeamsChannelsFromIndexedDB = "get_teams_channels_from_indexeddb",
  PutLegacyMessagesResolver = "put_legacy_messages_resolver",
  PutConversationsResolver = "put_conversations_resolver",
  ResolveEditClientLieResolver = "resolve_edit_client_lie_resolver",

  // Gap Detection
  OutOfOrderMessages = "gap_detection_out_of_order_messages",
  MissingMessages = "gap_detection_missing_messages",
  ArrivedAfterOutOfOrderWaitTime = "gap_detection_messages_arrived_after_outoforderwaittime",
  MessagesGapAboveThreshold = "gap_detection_messages_gap_above_threshold",

  // AsyncIterableObserver
  OnAsyncIterableObserverOverflow = "on_async_iterable_observer_overflow",

  // Core Settings
  EcsFetch = "ecs_provider_fetch",
  IPCPolicyFetch = "policy_service_fetch_ipc",
  NetworkPolicyFetch = "policy_service_fetch_network",

  // Messaging
  UpToEditBegin = "messaging_up_to_edit_message",
  SmsDeliveryReportFailure = "sms_delivery_report_failure",

  // Message Extension
  ExtMessageExtensionQueryCommand = "ext_me_queryCommand",

  // Card Actions
  ExtBotsInvoke = "ext_bots_invoke",
  ExtBotsMessageBack = "ext_bots_messageback",
  ExtBotsCardActionChatSendMessage = "ext_bots_card_action_chat_send_message",
  ExtBotsCardFetchTaskModule = "ext_bots_card_fetch_task_module",
  ExtBotsCardTaskSubmit = "ext_bots_card_task_submit",

  // Platform tab
  PlatformTabLoading = "platform_tab_loading",
  PlatformTabWebviewCreation = "platform_tab_webview_creation",

  // Platform tab SDK
  PlatformTabSdkGetAuthToken = "platform_tab_sdk_get_auth_token",
  PlatformTabSdkGetContext = "platform_tab_sdk_get_context",
  PlatformTabSdkGetUser = "platform_tab_sdk_get_user",

  // App definition queries used by cards
  ExtAppDefinitionForMECard = "ext_app_definition_for_me_card",
  ExtAppDefinitionsForBotCard = "ext_app_definitions_for_bot_card",

  // Share to Teams
  RenderOutlookPreview = "render_outlook_preview",
  RenderShareForm = "render_share_form",
  ShareFormErrorBoundary = "share_form_error_boundary",
  ShareFormFatalError = "share_form_fatal_error",
  STTOutlookAddInStartup = "stt_outlook_add_in_startup",
  STTOutlookPopulateUsage = "stt_outlook_populate_usage",
  SubmitShareForm = "submit_share_form",

  // Calling
  GetOngoingScenario = "get_ongoing_scenario",
  AdjacentRoomBanner = "adjacent_room_banner",
  ChatPaneFromCallRender = "chat_pane_from_call_render",
  ShareTrayRender = "share_tray_render",
  ShareTrayPreviewsLatency = "share_tray_previews_latency",
  RosterPanelRender = "roster_panel_render",
  CreateMeetingNotes = "create_meeting_notes",
  UbarMicrophoneRerendered = "toggle_mute_latency",
  RemoteMuteRender = "server_mute_latency",
  ChangeRoleRender = "change_role_latency",
  RemoveParticipantRender = "remove_participant_latency",
  NudgeParticipantRender = "nudge_participant_latency",
  ParticipantVbssLatency = "participant_vbss_latency",
  LowerOtherParticipantsHandLatency = "lower_other_participants_hand_latency",

  // Bot Profile Picture
  ExtBotProfilePictureUrl = "ext_bot_profile_picture_url",

  // Virtual List
  VirtualListInitialStableView = "vl_initial_stable_view",
  VirtualListLoadMore = "vl_load_more",
  VirtualListNewRenderWindow = "vl_new_render_window",
  VirtualListScrollToIndex = "vl_scroll_to_index",
  VirtualListScrollToBottom = "vl_scroll_to_bottom",

  // App installation
  InstallAppMessageExtensionJit = "ext_install_app_message_ext_jit",

  // App profile card
  AppProfileCardGetAppDefinition = "app_profile_card_get_app_definition",

  // LMS Integration
  LaunchLmsIntegration = "launch_lms_integration",
  EnableSchoolDataSyncForCourse = "enable_school_data_sync_for_course",
  GetTeamsForCourse = "get_teams_for_course",
  LmsIntegrationErrorBoundary = "lms_integration_error_boundary",

  // App based link
  AppBasedLinkInstall = "app_based_link_install"
}

// Individual steps for the scenarios listed above
// standardized step names for shared perf/health dashboard
export enum StepName {
  AppCacheMainJS = "appcache_main",
  AppCacheVendorJS = "appcache_vendor",
  DownloadScripts = "download_scripts",
  DownloadMainJs = "main",
  DownloadVendorJs = "vendor",
  EncodedBodySizeMainJS = "encoded_body_size_main",
  EncodedBodySizeVendorJS = "encoded_body_size_vendor",
  FetchData = "fetch_data",
  FetchQuerySend = "fetch_query_send",
  FetchWait = "fetch_wait",
  FetchProcessResponse = "fetch_process_response",
  Pause = "pause",
  Resume = "resume",
  Start = "start",
  Stop = "stop",
  QueryResult = "query_result",
  CdlWorkerBootstrapped = "cdl_worker_bootstrapped",
  CdlWorkerManagerLoaded = "cdl_worker_manager_loaded",
  CdlWorkerManagerHealthChecked = "cdl_worker_manager_health_checked",
  PlatformTabInitInvoke = "platform_tab_initialize_invoked",
  PlatformTabAppLoadedInvoke = "platform_tab_appLoaded_invoked",
  PlatformTabNotifySuccessInvoke = "platform_tab_success_invoked",
  PlatformTabNotifyFailureInvoke = "platform_tab_failure_invoked",

  // WLT Step Names:
  BeginWindowCreation = "begin_window_creation",
  EndWindowCreation = "end_window_creation",
  WindowContextProvider = "window_context_provider",
  RenderChatList = "render_chat_list",
  RenderChatPane = "render_chat_pane",
  RenderPlatformApp = "render_platform_app",
  PlatformFetchAppDefinition = "platform_fetch_app_definition",
  PlatformFetchTabInfo = "platform_fetch_tab_information",
  RenderProviders = "render_providers",
  RenderBaseApp = "render_base_app",
  RenderMessages = "render_messages",
  Unknown = "unknown",
  WindowCreated = "window_created",

  // Share to Teams
  STTDialogOpen = "stt_dialog_open",
  STTDialogTriggered = "stt_dialog_triggered",
  STTOutlookCallbackTokenComplete = "stt_outlook_callback_token_complete",
  STTOutlookMTCachedTokenComplete = "stt_outlook_mt_cached_token_complete",
  STTOutlookSSOComplete = "stt_outlook_sso_complete"
}

export type ScenarioStepStatus =
  | "success"
  | "failure"
  | "timeout" // framework will mark long lasting scenarios timeout after certain threshold
  | "abandoned" // user initiated
  | "incomplete" // not success, nor failure
  | "tab_switched" // indicates tab switched during the scenario execution
  | "app_minimized"; // indicates app minimized during the scenario execution
